import { render } from "./SegmentMultiDropdown.vue?vue&type=template&id=83179856&scoped=true"
import script from "./SegmentMultiDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentMultiDropdown.vue?vue&type=script&lang=ts"

import "./SegmentMultiDropdown.vue?vue&type=style&index=0&id=83179856&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-83179856"

export default script